// jQueryプラグイン
import 'jquery.easing';
export function indexFunc() {

  let indexTop = $('#indexTop').length;
    
  let storeListNavBtn = $('#storeListNavBtn');
  let countryName = $('.countryName');
  //const ajaxurl = "http://tenga-storelist.test/wp/wp-admin/admin-ajax.php";
  //const ajaxurl = "https://store.tenga.co/wp/wp-admin/admin-ajax.php";
  //const ajaxurl = "https://dev-store.tenga.co/wp/wp-admin/admin-ajax.php";
  let getUrl = location.host;
  //console.log(getUrl);
  
  var ajaxurl;

  if(getUrl == 'tenga-storelist.test'){
    ajaxurl = 'http://tenga-storelist.test/wp/wp-admin/admin-ajax.php';
  }else if(getUrl == 'dev-store.tenga.co'){
    ajaxurl = 'https://dev-store.tenga.co/wp/wp-admin/admin-ajax.php';
    
  }else if(getUrl == 'store.tenga.co'){
    ajaxurl = 'https://store.tenga.co/wp/wp-admin/admin-ajax.php';
  }else if(getUrl == 'store.acceptee-tenga.com'){
    ajaxurl = 'http://store.acceptee-tenga.com/wp/wp-admin/admin-ajax.php';
  }
  

  let ajaxFlag = true;
  let ajaxFlagMore = true;
  if (indexTop) {
     
    //地図サブナビ
    storeListNavBtn.on('click', function () {
        $(this).toggleClass('isOpen');
        $("html, body").animate({scrollTop: $('#storeListNav').offset().top}, 1200, 'easeInOutQuint');
        return false;
    });
    
    //地図をクリックした際の処理
    var thisMap, continent, countryArea, changeJs, areaList, currentList, mapName, responsibleCheck, activeSp;
    thisMap = $('.globalMap').find('#global_map').find('g');
    countryArea = $('.storeListCon');
    changeJs = $('.storeListNavMenu li');
            
    thisMap.hover(function () {
      continent = $(this).attr('id');
      $(this).find('path').addClass('cls-3'); 
      $(this).find('text').addClass('cls-4');
    }, function () {
      $(this).find('path').removeClass('cls-3'); 
      $(this).find('text').removeClass('cls-4');
    });
      
    thisMap.on('click', function () {
      areaList = $('section.' + continent);
      currentList = $('.storeListNavMenu li.' + continent);
      if ($(areaList).css('display') == 'none') {
        countryArea.not(areaList).css('display', 'none');
        areaList.css('display', 'block');
      };
        
      thisMap.removeClass('active');
      $(this).addClass('active'); 

      changeJs.removeClass('active');
      currentList.addClass('active');

      mapName = $(this).find('text').attr('id'); 
      $('.selectBtn').html(mapName).css({
          'color' : '#cc0111', 'text-transform' : 'uppercase'
      });
      responsibleCheck = $('#responsibleCheck').width();
      activeSp = $('.activeSp');

      if (responsibleCheck == '2') {
        $('#changeJs').slideUp(500);
        activeSp.removeClass('isOpen');
      }
        
       let storeListTop = $('#storeListNav').offset().top;
       $("html,body").animate({
            scrollTop:storeListTop
            }, 1200, 'easeInOutQuint');
            return false;
    });
 
    //地図サブナビをクリックした際の処理
      var thisArea, areaList,currentName;
      
      changeJs.on('click', function () {
        responsibleCheck = $('#responsibleCheck').width();
        thisArea = $(this).attr('class');
        areaList = $('section.' + thisArea);
        changeJs = $('#storeListNavMenu li');

        if ($(areaList).css('display') == 'none') {
          countryArea.not(areaList).css('display', 'none');
          areaList.css('display', 'block');
            
          $('g').removeClass('active');
          $('g#' + thisArea).addClass('active');
        }
          
          changeJs.removeClass('active');
          $(this).addClass('active');
          
          activeSp = $('.activeSp');
          if (responsibleCheck == '2') {
              $('#changeJs').slideUp(500);
              activeSp.removeClass('isOpen');
            }
          
          activeSp.removeClass('isOpen');
          
          currentName = $(this).html(); 
          $('.selectBtn').html(currentName).css({
              'color' : '#cc0111', 'text-transform' : 'uppercase'
          });
          
          let storeListTop = $('#storeListNav').offset().top;
            $("html,body").animate({
            scrollTop:storeListTop
            }, 1200, 'easeInOutQuint');
            return false;
      });
      
    //国名をクリックした時の処理
      countryName.on('click', function () {
          $(this).next().stop().slideToggle(600);
          $(this).toggleClass('active');
      });
    
    //国名をクリックした時の処理(ajax)
      countryName.one('click', function () {
          $(this).addClass('ajaxFalse');
          let country_id = $(this).attr('id');
          country_id = country_id.replace("country-", "");
          let sticky_id = $('#sticky-' + country_id).text();
          let countryStoreList = $('#list-' + country_id);
          //console.log(sticky_id);
        
        if (ajaxFlag) {
          ajaxFlag = false;
          $.ajax({
              type: 'POST',
              url: ajaxurl,
              data: {
                  'action' : 'my_ajax_get_store',
                  'country_id': country_id,
                  'sticky_id': sticky_id,
              },
            //dataType: 'json', //必須。json形式で返すように設定
          }).done(function(data) {
              var dataSticky = [];
              var dataStickyHtml = [];
              var dataAccordion = [];
              var dataAccordionHtml = [];
              data = JSON.parse(data);
              dataSticky = data['sticky'];
              dataAccordion = data['accordion'];
              //console.log(dataSticky);
              $.each(dataSticky, function(key, value){
                 dataStickyHtml.push('<div class="store tengaStore"><a href="' + value.url + '" target="_blank"><div class="storeImg"><img src="' + value.logo + '" alt="' + value.title + '"></div><p class="storeName">'+ value.title + '</p></a></div>');
                  $('#list-' + country_id + ' .flex').html(dataStickyHtml);
              });
            $.each(dataAccordion, function(key, value){
                dataAccordionHtml.push('<div class="store tengaStore"><a href="' + value.url + '" target="_blank"><div class="storeImg"><img src="' + value.logo + '" alt="' + value.title + '"></div><p class="storeName">'+ value.title + '</p></a></div>');
                  $('#accordion-' + country_id + ' .flex').html(dataAccordionHtml);
              });
          }).fail(function (xhr, status, error) {
              console.log("XMLHttpRequest : " + xhr.status);
              console.log("textStatus     : " + status);
              console.log("errorThrown    : " + error.message);
          }).always(function () {
              ajaxFlag = true;
          });
        };
        
        
      });
      

    //アコーディオンの処理
      let accordionBtn = $('.accordionCon + .accordionBtn');
      let accordionBtnTxt = $('.accordionCon + .accordionBtn p');
      
    //8件以下の時MOREボタンを消す
      $('.onlineCon').each(function () {
          let storeCount = $(this).find('.accordionCon .store').length;
          //if (storeCount <= 0) {
              //$(this).find('.accordionBtn').hide();
          //}
          
          //ランダム表示
          let randomContent = [];
          $(this).find('.store').not('.tengaStore').each(function () {
              randomContent.push($(this).html());
          });

          randomContent.sort(function () {
              return Math.random() - Math.random();
          });
          $(this).find('.store').not('.tengaStore').empty();
          let i = 0;
          $(this).find('.store').not('.tengaStore').each(function () {
              $(this).append(randomContent[i]);
              i++;
          });
          
          //moreボタンをクリックした時の処理
          $(this).find(accordionBtn).prev().hide();
          $(this).find(accordionBtn).click(function () {
              if ($(this).prev().is(':hidden')) {
                  $(this).prev().slideDown();
                  $(this).addClass('close');
                  $(this).find(accordionBtnTxt).text('CLOSE');
              } else {
                  $(this).prev().slideUp();
                  $(this).removeClass('close');
                  $(this).find(accordionBtnTxt).text('MORE');
              }
          });
      });

      
    //アメリカ・州名をクリックした時の処理
      let stateNavBtn = $('#stateNavBtn');
      let stateNavMenu = $('#stateNavMenu li');
      
      stateNavBtn.on('click', function () {
          $(this).next().stop().slideToggle(600);
          $(this).toggleClass('active');
      });
      
      stateNavMenu.on('click', function () {
          let thisStateArea = $(this).attr('class');
          let stateArea = $('div.' + thisStateArea);
          let storeMapList = $('.storeMapListAccordion');
          
          if ($(stateArea).css('display') == 'none') {
              storeMapList.not(stateArea).css('display', 'none');
              stateArea.css('display', 'block');
          }
          
          $('#stateNavBtn').next().stop().slideUp(600);
          stateNavBtn.removeClass('active');
          
          let stateName = $(this).html(); 
          $('.selectStateBtn').html(stateName);
      });
  }
}